export const CREATE_UNCERTAIN_MESSAGE =
  "We couldn't confirm whether account setup completed. Please try signing in, or contact support if the problem continues.";
export const ACCEPTANCE_UNCERTAIN_MESSAGE =
  "We couldn't confirm whether your invite was accepted. Please try signing in, or contact support if the problem continues.";
export const ACCEPTED_NOT_LOADED_MESSAGE =
  "Your invite was accepted, but we couldn't finish loading your account. Please try signing in, or contact support if the problem continues.";
